import { Header } from '../header'
import * as C from './styles'
import { FaGithub, FaInstagram , FaLinkedin, FaUser, FaRegWindowRestore, FaRegPaperPlane, FaJsSquare, FaHtml5, FaCss3Alt,FaGoogle, FaGithubSquare, FaReact, FaMoon} from "react-icons/fa";
import { SiMysql, SiPostgresql, SiStyledcomponents, SiTypescript, SiAdobephotoshop} from "react-icons/si";
import { Button } from '../features/button';
import { Project } from '../features/projectContainer';
import { Footer } from '../footer';
import Aos from 'aos';
import "aos/dist/aos.css"
import { useEffect } from 'react';
export const Blog = ()=>{
    const bottom = ()=>{
        window.scrollTo({
            top: 9999,
            behavior: 'smooth',
        });
    }
    useEffect(()=>{
        /*window.addEventListener('scroll', ()=>{
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        })*/
        Aos.init({
            duration: 2000
        })
    }, []);
    return(
        <C.Blog>
            <Header/>
            <main>
                <section  data-aos="fade-up" className='section__1'>
                    <div className='section_1--links'>
                        <a href="https://www.instagram.com/_eu_willian__/" target='_blank'><FaInstagram/></a>
                        <a href="https://github.com/Williansouzh" target='_blank'><FaGithub/></a>
                        <a href="https://www.linkedin.com/in/willian-souza-alves-99698b194/" target='_blank'><FaLinkedin/></a>
                    </div>
                    <div className='section_1--perfilimg'>
                        <img  src={require('../../assets/willian.jpg')} alt="perfil" />
                    </div>
                    <div className='section_1--scrolldown' >
                        <a onClick={bottom} href="#">Scsroll_down</a>
                    </div>
                </section>
                <section data-aos="fade-left" className='section__2'>
                    <h2><strong>ABOUT</strong></h2>
                    <div className='section__2--about'>
                        <div className='section__2--imgdContainer'>
                            <div className='section__2--imgBorder'>
                                <img src={require('../../assets/desktop.webp')} alt="desktop" />
                            </div>
                             <div className='section__2--expericenceTopics'>
                                <div className='section__2--expericenceTopic'>
                                    <FaRegPaperPlane className='section__2--icon'/>
                                    <strong>Experience</strong>
                                    <span>0</span>
                                </div>
                                <div className='section__2--expericenceTopic'>
                                    <FaUser className='section__2--icon'/>
                                    <strong>Clients</strong>
                                    <span>0</span>
                                </div>
                                <div className='section__2--expericenceTopic'>
                                    <FaRegWindowRestore className='section__2--icon'/>
                                    <strong>Projects</strong>
                                    <span>+10</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className='section__2--about-experience'>
                           
                            <p>Hello, my name is Willian, I'm 20 years old, I'm from Paraíba, from the city of Campina Grande. I currently work as an attendant at a telemarketing company. I would like to apply for a developer vacancy because I meet the requirements. I always liked to study, i have knowledge in HTML, CSS, JavaScript, TypeScript, database, React JS and I'm studying Node Js I have experience with graphic design. I do systems analysis and development. My studies are focused on mathematics, programming and English. I intend to become a high level full stack developer and work in big companies. In my github I have some projects I made to practice what I learned in class, where I used technologies and concepts like flexbox, display grid, styled-components, react-routes, context, and reducers and in the backend, express, sequelize and MVC. I consider myself a determined and organized person. My dream is to work on a big project that helps people, like Duolingo for example. Also, I enjoy doing calisthenics and running. In my free time I like to read, some of my favorite books are Anne Frank's diary and Dante's divine comedy.</p>
                            <Button primary text='Contact' />
                        </div>
                    </div>
                </section>
                <section  className='section__3'>
                    <h2><strong>MY SKILLS</strong></h2>
                    <div className='section__3--skillsContainer'>
                        <div data-aos="fade-right" className='section__3--skills'>
                            <h2>FrontEnd Development</h2>
                            <div  className='section__3--container'>
                                <div  className='section__3--skill'>
                                    <FaHtml5 className='icon'/> HTML
                                </div>
                                <div className='section__3--skill'>
                                    <FaJsSquare className='icon'/> JavaScript
                                </div>
                                <div className='section__3--skill'>
                                    <FaCss3Alt className='icon'/> CSS
                                </div>
                                <div className='section__3--skill'>
                                    <FaGithubSquare className='icon'/> GIT
                                </div>
                                <div className='section__3--skill'>
                                    <FaReact className='icon'/> REACT JS
                                </div>
                                <div className='section__3--skill'>
                                    <SiStyledcomponents className='icon'/> CSS IN JS
                                </div>
                                <div className='section__3--skill'>
                                    <SiAdobephotoshop className='icon'/> Photoshop
                                </div>
                            </div>
                        </div>
                        <div data-aos="fade-left" className='section__3--skills'>
                            <h2>BackEnd Development</h2>
                            <div className='section__3--container'>
                                <div className='section__3--skill'>
                                    <SiTypescript className='icon'/> TypeScript
                                </div>
                                <div className='section__3--skill'>
                                    <FaCss3Alt className='icon'/> Node JS
                                </div>
                                <div className='section__3--skill'>
                                    <SiMysql className='icon'/> MySQL
                                </div>
                                <div className='section__3--skill'>
                                    <SiPostgresql className='icon'/>PostgreSQL
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='section__4'>
                    <h2>MY WORKS</h2>
                    <div className='section__4--projectsContainer'>
                        <Project 
                            data-aos="fade-up"
                            name='Minimal Store' 
                            link='https://williansouzh.github.io/Minimal-Store/'
                            img={require('../../assets/project_minimalStore.PNG')}
                        />
                        <Project 
                            data-aos="fade-up"
                            name='Modern Website IA' 
                            link='https://modern-website-eight.vercel.app/'
                            img={require('../../assets/project_modernwebsite.PNG')}
                        />
                        <Project 
                            data-aos="fade-up"
                            name='TodoList Crud' 
                            link='https://todo-list-crud-with-node-mysql-and-react-5212ia3mj-williansouzh.vercel.app/'
                            img={require('../../assets/project_todocrud.png')}
                        />
                        <Project 
                            data-aos="fade-up"
                            name='Shopfy' 
                            link='https://williansouzh.github.io/shop-website-master/'
                            img={require('../../assets/project_shopfy.PNG')}
                        />
                        <Project 
                            data-aos="fade-up"
                            name='Musicfy website' 
                            link='https://williansouzh.github.io/Minimal-Store/'
                            img={'https://github.com/Williansouzh/landing-page-music/raw/master/assets/desktop.gif'}
                        />
                        <Project 
                            data-aos="fade-up"
                            name='Capitalism Game' 
                            link='https://williansouzh.github.io/CAPITALISM/'
                            img={require('../../assets/project_capitalism.PNG')}
                        />
                        <Project 
                            data-aos="fade-up"
                            name='Sel care website' 
                            link='https://williansouzh.github.io/selfcare/'
                            img={require('../../assets/project_selfcare.PNG')}
                        />
                        <Project 
                            data-aos="fade-up"
                            name='Responssive website' 
                            link='https://williansouzh.github.io/Site-responsivo/'
                            img={require('../../assets/project_shoping3.PNG')}
                        />
                        <Project 
                            data-aos="fade-up"
                            name='Headphone landing page' 
                            link='https://williansouzh.github.io/Fone-landing-page/'
                            img={require('../../assets/project_shoping2.PNG')}
                        />
                    </div>
                </section>
            </main>
            <Footer/>
        </C.Blog>
    )
}